import TableGroupHeader from './TableGroupHeader';

export type { TableGroupHeaderProps } from './TableGroupHeader';
export default TableGroupHeader;
